import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useRootStore = defineStore('root', () => {
  // State
  const baseUrl = ref(import.meta.env.VUE_APP_BASE_URL || process.env.VUE_APP_BASE_URL)
  const windowSize = ref(1200)
  
  // Actions
  function setWindowSize(size: number) {
    windowSize.value = size
  }
  
  function initializeWindow() {
    windowSize.value = window.innerWidth
    window.onresize = () => {
      windowSize.value = window.innerWidth
    }
  }
  
  function reset() {
    windowSize.value = 1200
  }
  
  return {
    // State
    baseUrl,
    windowSize,
    
    // Actions
    setWindowSize,
    initializeWindow,
    reset,
  }
}, {
  persist: {
    storage: sessionStorage,
  }
})
